import React, { useState } from "react";
import PieTurnover from "../../../Graphs/PieTurnover";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import localStrings from "../../../localStrings";
import BarTurnover from "../../../Graphs/BarTurnover";
import { Tab, Tabs, Box, useMediaQuery } from "@mui/material";
import {
    getUriSetting,
    saveUriSetting,
    SELECTED_TAB,
} from "../../../utils/optionsUriLocalStorage";
import {
    byLocationMode,
    byPaymentMissingMode,
    byPaymentTypeMode,
    byProductTypeMode,
    byStaffMode,
} from "../../../Graphs/constants";
import useAuth from "../../../hooks/useAuth";
import { filterSingleDay } from "../../Home/FilterInfoOverview";
import ClipLoaderComponent from "../../../components/ClipLoaderComponent";

function StaffData() {
    const { filter, loading } = useAuth();
    const [currentTab, setCurrentTab] = useState(getUriSetting(SELECTED_TAB) || "general");

    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

    const handleTabsChange = (event, value) => {
        saveUriSetting(SELECTED_TAB, value);
        setCurrentTab(value);
    };

    return (
        <PageWithTitle title={localStrings.turnover}>
            {/* Conteneur pour gérer l'affichage des Tabs sur mobile */}
            <Box
                sx={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    width: "100%",
                    "& .MuiTabs-root": {
                        minWidth: "100%",
                    },
                }}
            >
                <Tabs
                    onChange={handleTabsChange}
                    value={currentTab}
                    textColor="secondary"
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    <Tab label={localStrings.general} value="general" />
                    <Tab label={localStrings.byStaff} value={byStaffMode} />
                    <Tab label={localStrings.byProductType} value={byProductTypeMode} />
                    <Tab label={localStrings.byLocation} value={byLocationMode} />
                    <Tab label={localStrings.byPaymentType} value={byPaymentTypeMode} />
                    {/*<Tab label={localStrings.byPaymentMissing} value={byPaymentMissingMode} />*/}
                </Tabs>
            </Box>

            {/* Affichage du contenu selon l'onglet sélectionné */}
            {loading ? (
                <ClipLoaderComponent />
            ) : (
                <>
                    {currentTab === "general" && <BarTurnover title={localStrings.general} />}
                    {currentTab === byStaffMode && <BarTurnover displayMode={byStaffMode} title={localStrings.byStaff} />}
                    {currentTab === byProductTypeMode && <BarTurnover displayMode={byProductTypeMode} title={localStrings.byProductType} />}
                    {currentTab === byLocationMode && <BarTurnover displayMode={byLocationMode} title={localStrings.byLocation} />}
                    {currentTab === byPaymentTypeMode && <BarTurnover displayMode={byPaymentTypeMode} title={localStrings.byPaymentType} />}
                    {currentTab === byPaymentMissingMode && <BarTurnover displayMode={byPaymentMissingMode} title={localStrings.byPaymentMissing} />}
                </>
            )}
        </PageWithTitle>
    );
}

export default StaffData;
